import React, { useState, useEffect } from "react";
import config from "../../config"

// components
import PageTitle from "../../components/PageTitle";
import GenderSection from "./components/GenderSection";
import PartnerTypeSection from "./components/PartnerTypeSection";
import ServiceSection from "./components/ServiceSection";
import MembershipTypeSection from "./components/MembershipTypeSection";
import JobSection from "./components/JobSection";
import PaymentMethodSection from "./components/PaymentMethodSection";
import PaymentPeriodSection from "./components/PaymentPeriodSection";
import GroupTypePartnerSection from "./components/GroupTypePartnerSection";
import CategoryProductSection from "./components/CategoryProductSection";
import SaleUnitSection from "./components/SaleUnitSection";
import Modal from "../modals/Modal";
import EstablishmentSection from "./components/EstablishmentSection";
import SupplierSection from "./components/SupplierSection";
import PaymentConceptSection from "./components/PaymentConceptSection";
import FingerPrintSection from "./components/FingerPrintSection";
import OtherConceptSection from "./components/OtherConceptSection";

// styles
import useStyles from "./styles";

export default function Settings() {
  const classes = useStyles();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl + "genders/page/0");
  const [showPage, setShowPage] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchGenders = async () => {
    fetch(baseUrl,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setShowPage(true);
        } else {
          setShowModal(true);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fetchGenders();
  }, []);

  return (
    <>
      <div className={classes.divTitle}>
        <PageTitle title="Configuración" />
      </div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      {showPage ? (
        <div className={classes.divColumn} >
          <GenderSection />
          <PartnerTypeSection />
          <ServiceSection />
          <MembershipTypeSection />
          <JobSection />
          <PaymentMethodSection />
          <PaymentPeriodSection />
          <GroupTypePartnerSection />
          <CategoryProductSection />
          <SaleUnitSection />
          <SupplierSection/>
          <PaymentConceptSection/>
          <FingerPrintSection/>
          <OtherConceptSection/>
          {/*<EstablishmentSection/>*/}
        </div>
      ) : (
        <></>
      )}
      {/*<div className={classes.divSeparate}/>*/}
    </>
  );
}
